import eachDayOfInterval from 'date-fns/eachDayOfInterval'
import addDays from 'date-fns/addDays'
import subDays from 'date-fns/subDays'
import format from 'date-fns/format'
import { ptBR } from 'date-fns/locale'

const calendar = {

  daysInCalendar: 42,

  weekdays: {
    'domingo': 14,
    'segunda': 15,
    'terça': 16,
    'quarta': 17,
    'quinta': 18,
    'sexta': 19,
    'sábado': 20,
  },

  /**
   * Criar calendário com 42 dias
   */
  initCalendar: () => {
    const weekday = format(new Date, 'EE', { locale: ptBR })
    const daysBefore = calendar.weekdays[weekday]

    const startDay = subDays(new Date, daysBefore)
    const endDay = addDays(new Date, ((calendar.daysInCalendar - 1) - daysBefore))

    const allDaysOfInterval = eachDayOfInterval({
      start: startDay,
      end: endDay
    })

    allDaysOfInterval.forEach((day, index) => {
      const formattedDate = format(day, 'dd MMM EE', { locale: ptBR })
      
      const dayBlock = document.createElement('div')
      dayBlock.setAttribute('data-weekday', formattedDate.split(' ')[2])
      
      const span = document.createElement('span')

      const textDay = document.createElement('p')
      textDay.appendChild(span)
      textDay.appendChild(document.createTextNode(formattedDate.split(' ')[0]))
      if (formattedDate.split(' ')[0] == '01') textDay.appendChild(document.createTextNode(`/${formattedDate.split(' ')[1]}`))
      
      dayBlock.setAttribute('data-calendar-index', index)
      dayBlock.appendChild(textDay)

      document.getElementById('calendar').appendChild(dayBlock)
    })

    calendar.fillCalendar(daysBefore)
  },

  /**
   * Preenche o calendário com as informações de previsão
   */
  fillCalendar: (position) => {
    const todayBlock = document.querySelector(`[data-calendar-index='${position}'] > p > span`)
    todayBlock.innerHTML = 'Hoje'

    const tomorrowBlock = document.querySelector(`[data-calendar-index='${position + 1}'] > p > span`)
    tomorrowBlock.innerHTML = 'Amanhã'

    const data = JSON.parse(document.getElementById('calendar').dataset.infos)

    data.forEach((item, index) => {
      if (Object.keys(item.textIcon).length) {
        let icon = document.createElement('img')
        icon.setAttribute('src', `/dist/images/v2/svg/${item.textIcon.icon.day}.svg`)
        icon.setAttribute('height', '30')
        icon.setAttribute('width', '30')
        icon.setAttribute('alt', item.textIcon.text.pt)

        const dailyBlock = document.querySelector(`[data-calendar-index='${position + index}']`)
        
        let wrapperAlertIcon = document.createElement('div')
        wrapperAlertIcon.setAttribute('class', 'wrapper-alert-icon')
        wrapperAlertIcon.appendChild(icon)

        if (item.hasTemperatureAlert) {
          let iconAlert = document.createElement('span')
          iconAlert.setAttribute('class', 'fa fa-exclamation-triangle')

          wrapperAlertIcon.appendChild(iconAlert)
        }

        dailyBlock.appendChild(wrapperAlertIcon)
        dailyBlock.setAttribute('data-modal', 'forecast-stories')
        dailyBlock.setAttribute('id', `Calendario_previsao_dia_${index + 1}_15_dias`)
        dailyBlock.setAttribute('data-id', index)
        dailyBlock.setAttribute('data-category', `Pagina_previsao_15_dias`)
        dailyBlock.setAttribute('data-action', `Clique_dia_${index + 1}_calendario_15_dias`)
        dailyBlock.setAttribute('data-label', `Dia_${index + 1}_calendario_15_dias`)
        dailyBlock.classList.add('_pointer', '-bold', 'act-control-modal', 'act-control-forecast-stories', 'actTriggerGA')

        dailyBlock.querySelector('p').setAttribute('class', '-gray')
      }
    })
  },

}

export default calendar